import React from 'react'
import PDFReader from '../../Components/Commons/PDFReader'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import ReactPlayer from 'react-player'

export const RoleStr = {
    GUEST: '게스트',
    CLIENT: '건축주',
    ARCHITECT: '건축가',
    CONSTRUCTOR: '건설사',
    SUPERVISOR: '감리자',
    INTERIOR: '인테리어',
    ADMIN: '플래너',
    SUPER_ADMIN: '슈퍼관리자',
}

export const RoleType = {
    GUEST: 'GUEST',
    CLIENT: 'CLIENT',
    ARCHITECT: 'ARCHITECT',
    CONSTRUCTOR: 'CONSTRUCTOR',
    SUPERVISOR: 'SUPERVISOR',
    INTERIOR: 'INTERIOR',
    ADMIN: 'ADMIN',
    SUPER_ADMIN: 'SUPER_ADMIN',
}

export const getThumbnailSVG = function(group, size) {
    let thumbnail = ''

    if (group === 'CLIENT') {
        thumbnail = (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <circle cx="12" cy="12" r="11.5" fill="#EBE6FF" stroke="#7D5FFF" />
                    <path
                        fill="#7D5FFF"
                        d="M20.414 20.51a8.58 8.58 0 0 0-16.013.429c-.144.406 2.992 2.354 6.8 2.592 4.574.286 9.245-2.943 9.213-3.021z"
                    />
                    <circle cx="12" cy="9" r="4" fill="#7D5FFF" />
                </g>
            </svg>
        )
    } else if (group === 'ARCHITECT') {
        thumbnail = (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <circle cx="12" cy="12" r="11.5" fill="#FFEDEC" stroke="#FF6154" />
                    <path
                        fill="#FF6154"
                        d="M20.414 20.51a8.58 8.58 0 0 0-16.013.429c-.144.406 2.992 2.354 6.8 2.592 4.574.286 9.245-2.943 9.213-3.021z"
                    />
                    <circle cx="12" cy="9" r="4" fill="#FF6154" />
                </g>
            </svg>
        )
    } else if (group === 'CONSTRUCTOR') {
        thumbnail = (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <circle cx="12" cy="12" r="11.5" fill="#E5F5FF" stroke="#31ACFF" />
                    <path
                        fill="#31ACFF"
                        d="M20.414 20.51a8.58 8.58 0 0 0-16.013.429c-.144.406 2.992 2.354 6.8 2.592 4.574.286 9.245-2.943 9.213-3.021z"
                    />
                    <circle cx="12" cy="9" r="4" fill="#31ACFF" />
                </g>
            </svg>
        )
    } else if (group === 'INTERIOR') {
        thumbnail = (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <circle cx="12" cy="12" r="11.5" fill="#E0FFFC" stroke="#30C5B6" />
                    <path
                        fill="#30C5B6"
                        d="M20.414 20.51a8.58 8.58 0 0 0-16.013.429c-.144.406 2.992 2.354 6.8 2.592 4.574.286 9.245-2.943 9.213-3.021z"
                    />
                    <circle cx="12" cy="9" r="4" fill="#30C5B6" />
                </g>
            </svg>
        )
    } else if (group === 'SUPERVISOR') {
        thumbnail = (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <circle cx="12" cy="12" r="11.5" fill="#EBE6FF" stroke="#FFAF27" />
                    <path
                        fill="#7D5FFF"
                        d="M20.414 20.51a8.58 8.58 0 0 0-16.013.429c-.144.406 2.992 2.354 6.8 2.592 4.574.286 9.245-2.943 9.213-3.021z"
                    />
                    <circle cx="12" cy="9" r="4" fill="#7D5FFF" />
                </g>
            </svg>
        )
    } else if (group === 'ADMIN') {
        thumbnail = (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <circle cx="12" cy="12" r="11.5" fill="#FBFFC1" stroke="#ACB700" />
                    <path
                        fill="#ACB700"
                        d="M20.414 20.51a8.58 8.58 0 0 0-16.013.429c-.144.406 2.992 2.354 6.8 2.592 4.574.286 9.245-2.943 9.213-3.021z"
                    />
                    <circle cx="12" cy="9" r="4" fill="#ACB700" />
                </g>
            </svg>
        )
    } else {
        thumbnail = (
            <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
                <g fill="none" fillRule="evenodd">
                    <circle cx="12" cy="12" r="11.5" fill="#FBFFC1" stroke="#ACB700" />
                    <path
                        fill="#ACB700"
                        d="M20.414 20.51a8.58 8.58 0 0 0-16.013.429c-.144.406 2.992 2.354 6.8 2.592 4.574.286 9.245-2.943 9.213-3.021z"
                    />
                    <circle cx="12" cy="9" r="4" fill="#ACB700" />
                </g>
            </svg>
        )
    }

    return thumbnail
}

export const renderFiles = function(files) {
    const List = files.map((item, index) => {
        return (
            <a href={item.url} download className="download_file" key={index}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                    <path
                        fill="none"
                        fillRule="evenodd"
                        stroke="#A2A7AE"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.3"
                        d="M12.9 6.632l-5.484 5.643a3.512 3.512 0 0 1-5.067 0C.95 10.835.95 8.502 2.35 7.062L7.834 1.42a2.341 2.341 0 0 1 3.377 0c.933.96.933 2.515 0 3.475l-5.49 5.642a1.17 1.17 0 0 1-1.689 0 1.254 1.254 0 0 1 0-1.737L9.1 3.593"
                    />
                </svg>

                {item.filename || item.name}
            </a>
        )
    })

    return List
}

export const renderPDFFiles = function(files) {
    const List = files
        .map((item, index) => {
            if (item.url && item.url.match(/.(pdf|csv)$/i)) {
                return (
                    <div className="file_view">
                        {/* <iframe src={'https://docs.google.com/viewer?embedded=true&url=' + encodeURIComponent(item.fileUrl) + ''} /> */}
                        <PDFReader url={item.url} />
                    </div>
                )
            }
        })
        .filter((notUndefined) => notUndefined !== undefined)

    if (List.length > 0) {
        return (
            <div className="text_wrap">
                <div className="content">{List}</div>
            </div>
        )
    }
}

export const renderImageFiles = function(files) {
    const List = files
        .map((item, index) => {
            if (item.url && item.url.match(/.(jpg|jpeg|png|gif)$/i)) {
                return (
                    <TransformWrapper
                        wheel={{
                            disabled: false,
                            wheelEnabled: false,
                        }}
                        pan={{
                            disabled: true,
                        }}
                        doubleClick={{
                            disabled: true,
                        }}>
                        {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                            <TransformComponent>
                                <img src={item.url} />
                            </TransformComponent>
                        )}
                    </TransformWrapper>
                )
            }
        })
        .filter((notUndefined) => notUndefined !== undefined)

    if (List.length > 0) {
        return (
            <div className="text_wrap">
                <div className="content">{List}</div>
            </div>
        )
    }
}

export const renderOfficeFiles = function(files) {
    const List = files
        .map((item, index) => {
            if (item.url && item.url.match(/.(xlsx|xls|ppt|pptx|doc|docx)$/i)) {
                return (
                    <div className="file_view">
                        <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${item.url}`} />
                    </div>
                )
            }
        })
        .filter((notUndefined) => notUndefined !== undefined)

    if (List.length > 0) {
        return (
            <div className="text_wrap">
                <div className="content">{List}</div>
            </div>
        )
    }
}

export const renderVideoFiles = function(files) {
    const List = files.map((item, index) => {
        if (item.url && item.url.match(/.(mp4|avi|webm)$/i)) {
            return (
                <div className="file_view">
                    <div className="iframe_wrap">
                        <ReactPlayer
                            className="video"
                            url={item.url}
                            controls={true}
                            width="100%"
                            height="100%"
                            crossOrigin="anonymous"
                            // muted="true"
                            // onError={this.onVideoErrorHandler}
                            // onReady={this.onVideoReadyHandler}
                        />
                    </div>
                </div>
            )
        }
    })

    return List
}



// WEBPACK FOOTER //
// ./Src/Components/Commons/Utils.js